import { useState, useEffect } from 'react';
import { recaptchaSiteKey } from '../services/env';
import useCheckoutState from './useCheckoutState';

export default function useRecaptcha() {
  const { seller } = useCheckoutState();
  const [recaptchaLoaded, setRecaptchaLoaded] = useState(false);

  const recaptchaEnabled = seller?.captcha?.recaptcha?.enabled === true;

  useEffect(() => {
    if (recaptchaLoaded) return;
    if (!recaptchaEnabled) return;

    const script = document.createElement('script');
    script.src = `https://www.google.com/recaptcha/api.js?render=${recaptchaSiteKey}&trustedtypes=true`;
    script.async = true;
    script.id = 'recaptcha-script';
    document.body.appendChild(script);

    script.onload = () => {
      window.grecaptcha.ready(() => {
        setRecaptchaLoaded(true);
      });
    };

    return () => {
      document.body.removeChild(script);
    };
  }, [recaptchaEnabled, recaptchaLoaded]);

  async function executeRecaptcha(action = 'submit') {
    if (!recaptchaEnabled || !recaptchaLoaded) {
      return null;
    }

    return window.grecaptcha.execute(recaptchaSiteKey, { action });
  }

  return {
    executeRecaptcha,
  };
}
